import { Component } from '@angular/core';
import { SOLUTION_PAGE_CONFIGS } from 'src/app/shared/components/solution-page/solution-page.config';

@Component({
  selector: 'app-solution3',
  templateUrl: './solution3.component.html',
  styleUrls: ['./solution3.component.scss'],
})
export class Solution3Component {
  readonly pageConfig = SOLUTION_PAGE_CONFIGS[3];
}
